/**
 * plugins/logos-target.ts — Ferramenta para redimensionar a logo da TargetTI (logos_target)
 *
 * Ferramentas: alterar largura (width), excluir.
 */

import { VtbPlugin, IVtbRegistry, SmartCtx, closestInside } from '../types';

export class LogosTargetPlugin implements VtbPlugin {
    readonly panelId = 'vtb-logos-target';
    readonly selectorHints = ['img[src*="logo-targetit"]', '[data-vtb-id="logo"]'];

    detect(target: HTMLElement, visualEditor: HTMLElement): SmartCtx | null {
        // Agora usa o ID injetado no JSON ou o fallback automático
        const el = closestInside(target, visualEditor, e => 
            e.dataset.vtbId === 'logo' || 
            (e.tagName === 'IMG' && (e as HTMLImageElement).src.includes('logo-targetit'))
        );
        
        if (!el) return null;
        
        return { type: this.panelId, label: 'Logo', el };
    }

    activate(ctx: SmartCtx, registry: IVtbRegistry): void {
        const el = ctx.el as HTMLImageElement;
        const widthIn = registry.q<HTMLInputElement>('vtb-logo-width');
        const altIn = registry.q<HTMLInputElement>('vtb-logo-alt');
        const typeSel = registry.q<HTMLSelectElement>('vtb-logo-type');

        if (widthIn) {
            const currentWidth = el.getAttribute('width') || el.style.width.replace('px', '');
            widthIn.value = currentWidth || '135';
        }

        if (altIn) {
            altIn.value = el.alt || '';
        }

        if (typeSel) {
            const src = el.src;
            if (src.includes('logo-targetit-colorido.png')) {
                typeSel.value = 'logo-targetit-colorido.png';
            } else {
                typeSel.value = 'logo-targetit-branco.png';
            }
        }
    }

    setup(registry: IVtbRegistry): void {
        registry.q('vtb-logo-width')?.addEventListener('input', () => this._sync(registry));
        registry.q('vtb-logo-alt')?.addEventListener('input', () => this._sync(registry));
        registry.q('vtb-logo-type')?.addEventListener('change', () => this._sync(registry));
        registry.q('vtb-logo-del')?.addEventListener('click', () => this._delete(registry));
    }

    private _sync(registry: IVtbRegistry): void {
        const ctx = registry.activeCtx;
        if (!ctx) return;
        
        const el = ctx.el as HTMLImageElement;
        const width = registry.q<HTMLInputElement>('vtb-logo-width')?.value?.trim();
        const alt = registry.q<HTMLInputElement>('vtb-logo-alt')?.value?.trim();
        const type = registry.q<HTMLSelectElement>('vtb-logo-type')?.value;
        
        if (width) {
            el.setAttribute('width', width);
            el.style.width = width + 'px';
            el.style.height = 'auto';
        }

        if (alt !== undefined) {
            el.alt = alt || '';
        }

        if (type) {
            // Aqui assumimos que temos acesso às urls reais ou placeholders
            // No seeder usamos ${LOGO_TARGET}, mas aqui o src já está resolvido
            // Para trocar, precisamos saber o base path ou apenas trocar o filename final
            const currentSrc = el.src;
            const newSrc = currentSrc.replace(/logo-targetit-(branco|colorido)\.png/, type);
            if (currentSrc !== newSrc) {
                el.src = newSrc;
            }
        }
        
        registry.sync();
    }

    private _delete(registry: IVtbRegistry): void {
        const ctx = registry.activeCtx;
        if (!ctx) return;
        
        ctx.el.remove();
        registry.clearSelection();
        registry.sync();
    }
}
